import { render, staticRenderFns } from "./waiterManagerDetail.vue?vue&type=template&id=58733fce&scoped=true&"
import script from "./waiterManagerDetail.vue?vue&type=script&lang=js&"
export * from "./waiterManagerDetail.vue?vue&type=script&lang=js&"
import style0 from "./waiterManagerDetail.vue?vue&type=style&index=0&id=58733fce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58733fce",
  null
  
)

export default component.exports